
import { Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { 
  Popover,
  PopoverContent,
  PopoverTrigger 
} from "@/components/ui/popover";
import { useEffect, useState } from "react";
import { BlogPostShareLinks } from "./BlogPostShareLinks";

interface BlogPostShareButtonProps {
  title?: string;
}

export const BlogPostShareButton = ({ title }: BlogPostShareButtonProps) => {
  const { toast } = useToast();
  const [isBrowser, setIsBrowser] = useState(false);
  
  // Set isBrowser to true once component is mounted on client
  useEffect(() => {
    setIsBrowser(typeof window !== 'undefined');
  }, []);
  
  // Skip rendering share functionality during SSR
  if (!isBrowser) {
    return (
      <div className="flex justify-end mb-10">
        <Button variant="outline" className="flex items-center gap-2" asChild>
          <span>
            <Share2 className="h-4 w-4" />
            Condividi
          </span>
        </Button>
      </div>
    );
  }
  
  // Construct current URL for sharing
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  
  // Native share API handling
  const handleNativeShare = () => {
    if (navigator.share) {
      navigator.share({
        title: title || "Articolo Gildy",
        url: currentUrl
      }).catch(err => {
        console.error("Errore nella condivisione:", err);
      });
    }
  };
  
  // Render with native share API if available, otherwise use our custom popover
  if (navigator.share) {
    return (
      <div className="flex justify-end mb-10">
        <Button 
          onClick={handleNativeShare} 
          variant="outline" 
          className="flex items-center gap-2"
        >
          <Share2 className="h-4 w-4" />
          Condividi
        </Button>
      </div>
    );
  }
  
  // Fallback to custom share links popover
  return (
    <div className="flex justify-end mb-10">
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="flex items-center gap-2">
            <Share2 className="h-4 w-4" />
            Condividi
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-4">
          <div className="space-y-2">
            <h4 className="font-medium text-sm mb-2">Condividi articolo</h4>
            <BlogPostShareLinks title={title || "Articolo Gildy"} />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
